import { render, staticRenderFns } from "./edit-dialog.vue?vue&type=template&id=301853bc&scoped=true"
import script from "./edit-dialog.vue?vue&type=script&lang=ts"
export * from "./edit-dialog.vue?vue&type=script&lang=ts"
import style0 from "./edit-dialog.vue?vue&type=style&index=0&id=301853bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301853bc",
  null
  
)

export default component.exports